import moment from 'moment'

const formatChartLabel = (data: any, format: string) => {
    let timeFormat = 'HH:00'
    let result: any = []

    const newData = data?.filter((res: any) => res.nav !== null)
    switch (format) {
        case '1D':
            timeFormat = 'HH:00'
            break
        default:
            timeFormat = 'MM/DD'
            break
    }

    newData?.forEach((element: any) => {
        result.push(moment.unix(element.t).format(timeFormat))
    })

    return result
}

const isNextMonth = (time: number) => {
    const CurrentDate = moment()
    const nextMonth = moment(time).add(1, 'M').set('date', 1)
    return CurrentDate.isSameOrAfter(moment(nextMonth))
}

export const MOMENT_UTIL = {
    formatChartLabel,
    isNextMonth,
}
